import { createSliceSelectors } from '../utils'

const StopDescriptionSelectors = createSliceSelectors('stopDescription', ['isOpen', 'mediaType'])

export default StopDescriptionSelectors
